<template>
  <div class="body">
    <el-container>
      <!-- <ReportsAside /> -->
      <el-main>
        <div class="bg-White p-5 mt-2">
          <el-row :gutter="10">
            <el-col :xl="4" :lg="4" :md="6" :sm="12"> </el-col>
            <el-col :xl="10" :lg="10" :md="6" :sm="12">
              <div class="block">
                <!-- <span class="demonstration">Default</span> -->
                <el-date-picker
                  @change="getProfites(1)"
                  v-model="dateRange"
                  type="daterange"
                  range-separator="الي"
                  format="yyyy/MM/dd"
                  value-format="yyyy-MM-dd"
                  start-placeholder="بداية الفترة"
                  end-placeholder="نهاية الفترة"
                >
                </el-date-picker>
              </div>
            </el-col>
            <el-col :xl="8" :lg="8" :md="6" :sm="12">
              <el-button type="success" @click="getProfites(1)"
                >التقرير اليومي</el-button
              >
              <el-button type="warning" class="mr-2" @click="getProfites(2)"
                >التقرير الشهري</el-button
              >
            </el-col>
            <el-col :xl="2" :lg="2" :md="6" :sm="12">
              <el-button
                type="success"
                title="طباعه"
                icon="el-icon-printer"
                @click="sendToPrintAll(report)"
              ></el-button>
            </el-col>
          </el-row>
        </div>
        <el-table
          class="mt-2"
          align="right"
          v-if="report.length > 0"
          :data="report"
          border
          show-summary
          sum-text="الاجمالي"
          style="overflow: auto; width: 100%"
        >
          <el-table-column label="#" type="index" width="80"> </el-table-column>
          <el-table-column :label="isDaily ? 'اليوم' : 'الشهر'">
            <template slot-scope="scope">
              <span v-if="isDaily">
                {{ scope.row.date | moment("dddd | Do / MM / YYYY") }}
              </span>
              <span v-else>
                {{ scope.row.date | moment("MMMM") }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="مبيعات" prop="totalSales"> </el-table-column>
          <el-table-column label="خصومات" prop="totalSalesDiscount">
          </el-table-column>
          <el-table-column label="التكلفة" prop="total_buy"> </el-table-column>
          <el-table-column label="الربح" prop="profit"> </el-table-column>
          <el-table-column label="المشتريات" prop="totalPurchases">
          </el-table-column>
          <el-table-column label="مصروفات" prop="shopExpenses">
          </el-table-column>
        </el-table>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import axiosApi from "@/plugins/axios.js";
// import ReportsAside from "@/components/ReportsAside.vue";
// import { ipcRenderer } from "electron";

export default {
  name: "Products",
  // components: { ReportsAside },
  data() {
    return {
      buyCost: 0,
      totalDiscount: 0,
      saleCost: 0,
      true: true,
      productsLength: 0,
      customer: null,
      dateRange: null,
      editFormVisible: false,
      tableData: [],
      selectedProduct: null,
      productCategories: [],
      name: "",
      searchCode: "",
      selectedCategory: "",
      current_page: 1,
      page_limit: 1,
      adminValid: false,
      isDaily: true,
      password: "",
      showItem: false,
      profitAsce: false,
      qtyAsce: true,
      productsReport: null,
      totalQty: 0,
      shopExpenses: 0,
      productsSalesDiscount: 0,
      totalSaleCost: 0,
      totalPurchases: 0,
      totalPurchasesDiscount: 0,
      totalSalesDiscount: 0,
      totalBuyCost: 0,
      totalReturnedQty: 0,
      totalReturnedCost: 0,
      totalReturnedBuy: 0,
      totalFilteredQty: 0,
      totalFilteredSaleCost: 0,
      totalFilteredSaleDiscount: 0,
      totalFilteredBuyCost: 0,
      totalFilteredReturnedQty: 0,
      totalFilteredReturnedCost: 0,
      totalFilteredReturnedDiscount: 0,
      totalFilteredReturnedBuy: 0,
      report: [],
    };
  },
  created() {},
  methods: {
    numberToFixed(number) {
      return Number(number).toFixed(2);
    },
    getProfites(type) {
      if (this.dateRange != null) {
        const loading = this.$loading({
          lock: true,
          text: "جاري تحميل البيانات",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        let bathUrl = `/sales-days-profites/1/${this.dateRange[0]}/${this.dateRange[1]}`;
        if (type == 1) {
          this.isDaily = true;
          bathUrl = `/sales-days-profites/1/${this.dateRange[0]}/${this.dateRange[1]}`;
        } else {
          this.isDaily = false;
          bathUrl = `/sales-months-profites/1/${this.dateRange[0]}/${this.dateRange[1]}`;
        }
        axiosApi
          .get(bathUrl)
          .then((response) => {
            this.report = response.data.productsSaleReport;
            //  this.totalReturnedDiscount = response.data.sumReturnedSalesDiscount;
            //  this.productsReport=this.report;
            let sumQty = 0;
            let sumSaleCost = 0;
            let sumBuyCost = 0;
            let sumReturnedQty = 0;
            let sumReturned = 0;
            let sumBuyReturned = 0;
            let sumPurchases = 0;
            let sumPurchasesDiscount = 0;
            let sumSalesDiscount = 0;
            let sumExpenses = 0;
            let vm = this;
            this.report.map(function (value) {
              sumQty += value["total_qty"];
              sumBuyCost += value["total_buy"];
              sumReturned += value["returnedCost"];
              sumBuyReturned += value["sumBuyReturned"];
              sumSalesDiscount += value["totalSalesDiscount"];
              sumPurchasesDiscount += value["totalPurchasesDiscount"];
              sumPurchases += value["totalPurchases"];
              sumExpenses += value["shopExpenses"];
              sumSaleCost += value["totalSales"];
              value["profit"] = vm.numberToFixed(
                value["totalSales"] -
                  value["total_buy"] -
                  value["totalSalesDiscount"]
              );
              value["totalSales"] = vm.numberToFixed(value["totalSales"]);
              value["totalSalesDiscount"] = vm.numberToFixed(
                value["totalSalesDiscount"]
              );
              value["total_buy"] = vm.numberToFixed(value["total_buy"]);
              value["shopExpenses"] = vm.numberToFixed(value["shopExpenses"]);
              value["totalPurchases"] = vm.numberToFixed(
                value["totalPurchases"]
              );
            });
            this.totalQty = sumQty;
            this.totalBuyCost = sumBuyCost;
            this.totalSaleCost = sumSaleCost;
            this.totalReturnedQty = sumReturnedQty;
            this.totalReturnedCost = sumReturned;
            this.totalReturnedBuy = sumBuyReturned;
            this.shopExpenses = sumExpenses;
            this.totalPurchases = sumPurchases;
            this.totalPurchasesDiscount = sumPurchasesDiscount;
            this.totalSalesDiscount = sumSalesDiscount;
          })
          .catch((e) => {
            console.log(e);
          })
          .finally(() => {
            loading.close();
          });
      }
    },
    sendToPrintAll(report) {
      console.log("🚀 ~ sendToPrintAll ~ report:", report)
      // window.ipcRenderer = ipcRenderer;
      // let data = {
      //   data: report,
      //   type: "Profites",
      //   dateRange: this.dateRange,
      //   title: this.isDaily,
      //   img:
      //     "https://pos.staging.fatura-app.com" +
      //     JSON.parse(localStorage.getItem("branch")).logo,
      // };
      // ipcRenderer.send("printing", data);
    },
  },
};
</script>

<style scoped>
.el-table {
  width: 100%;
  max-height: 80%;
  overflow-y: scroll;
}
</style>
